import axios, { AxiosRequestConfig, AxiosPromise } from 'axios'

type graphQlData = {
  query: string
  variables?: unknown
  operationName?: unknown
  csrf?: string
}

export const graphql = (
  query: string,
  variables: unknown,
  operationName: unknown,
  csrf: string = ''
) => {
  const data: graphQlData = { query }
  if (variables) {
    data.variables = variables
  }
  if (operationName) {
    data.operationName = operationName
  }
  let axiosResponse: AxiosPromise<any> = axios({
    url: '/offers/graphql',
    method: 'post',
    origin: 'same-origin',
    headers: {
      'x-csrf-token': csrf
    },
    data
  } as AxiosRequestConfig)

  return new Promise((resolve, reject) => {
    axiosResponse.then(resolve).catch((error: any) => {
      reject(error)
    })
  })
}

export default graphql
